import React from 'react';
import { ArrowRight, HeartHandshake, Users, Wrench } from 'lucide-react';
const CRAFT_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/0b4f079d-a091-41e0-aa11-e12a5078a1df.jpg';
const pillars = [{
  icon: Wrench,
  title: 'Built for Colorado',
  body: 'As Colorado natives, we know what hail, wind, and freeze-thaw cycles do to a home — and we build for it.'
}, {
  icon: Users,
  title: 'Lives Restored Mentorship',
  body: 'We invest in our people through mentorship and growth, so the crew in your home shows up as their best.'
}, {
  icon: HeartHandshake,
  title: 'Projects, places & people',
  body: 'We restore all three — bringing them back to, or better than, their best.'
}];
export function About() {
  return <section id="about" className="bg-white py-20 md:py-28" data-id="element-1" data-mp="3mc9w6junmouh">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-2 lg:gap-20" data-id="element-2" data-mp="3mduqq9gyy7sc">
        <div className="relative" data-id="element-3" data-mp="3rbwirjwdhhfy">
          <div className="overflow-hidden rounded-3xl" data-id="element-4" data-mp="2pxv63e6pager">
            <img src={CRAFT_IMAGE} alt="Custom built-in shelving and trim work completed by Restored Services" className="h-full w-full object-cover" data-id="element-5" data-mp="2pzg1t74r45e7" />
          </div>
          <div className="absolute -bottom-6 left-6 hidden rounded-2xl border border-black/5 bg-white p-5 shadow-xl sm:block" data-id="element-6" data-mp="2g5z8s5cfuubl">
            <p className="font-heading text-3xl font-semibold text-brand" data-id="element-7" data-mp="38wh94yls2hlb">50+</p>
            <p className="mt-1 max-w-[10rem] text-sm leading-snug text-ink-soft" data-id="element-8" data-mp="38ud8cpj6dyp9">
              years of combined restoration &amp; remodeling experience
            </p>
          </div>
        </div>

        <div data-id="element-9" data-mp="2z0e7ruyr2mzf">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-brand" data-id="element-10" data-mp="2uwyaqxirqkm7">
            Welcome to Restored Services Colorado
          </p>
          <h2 className="mt-4 font-heading text-3xl font-semibold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-11" data-mp="1nkxy2wlj6vac">
            We do more than build — we restore, remodel, and revitalize.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-12" data-mp="1kzhwg0tz7yno">
            With over 50 years of combined experience in restoration, remodeling,
            roofing, and repair, we bring expert craftsmanship and a deep love for
            our Colorado community to every project. We understand the challenges
            of our ever-changing weather, and we&apos;re dedicated to keeping your
            home protected and thriving through every season.
          </p>

          <ul className="mt-9 space-y-6" data-id="element-13" data-mp="1708nnm83o6tq">
            {pillars.map(pillar => <li key={pillar.title} className="flex gap-4" data-id="element-14" data-mp="sasy29kb27fm">
                <span className="mt-0.5 inline-flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-brand-tint text-brand" data-id="element-15" data-mp="s8g93cg4qwt2">
                  <pillar.icon className="h-5 w-5" aria-hidden="true" data-id="element-16" data-mp="j9cp86952ddi" />
                </span>
                <div data-id="element-17" data-mp="nbptsrc5g58p">
                  <h3 className="font-heading text-base font-semibold text-ink" data-id="element-18" data-mp="n9wlz8psvez4">
                    {pillar.title}
                  </h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-ink-soft" data-id="element-19" data-mp="4oqs7nx87lsq">
                    {pillar.body}
                  </p>
                </div>
              </li>)}
          </ul>

          <a href="#quote" className="group mt-10 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-brand" data-id="element-20" data-mp="dl7v63vfsdde">
            Book your free quote
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-21" data-mp="ilm5jskifzel" />
          </a>
        </div>
      </div>
    </section>;
}